/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Display name variant for the document. 'estimate' renders as 'Estimate' (Ponudba/Ponuda), 'proforma_invoice' renders as 'Proforma invoice' (Predračun).
 * @nullable
 */
export type CompleteEstimatePreviewTitleType = typeof CompleteEstimatePreviewTitleType[keyof typeof CompleteEstimatePreviewTitleType] | null;


export const CompleteEstimatePreviewTitleType = {
  estimate: 'estimate',
  proforma_invoice: 'proforma_invoice',
} as const;
